import { Obj } from "../internal";
export class CursorStyleHandler extends Obj {
    constructor(scene) {
        super();
        this._currentStyle = "default";
        this.scene = scene;
        this.engine = scene.engine;
    }
    setCursorStyle(style) {
        if (style) {
            this._currentStyle = style;
            this.engine.getCanvas().style.cursor = this._currentStyle;
        }
        else {
            this.resetCursorStyle();
        }
    }
    getCursorStyle() {
        return this._currentStyle;
    }
    resetCursorStyle() {
        this._currentStyle = "default";
        this.engine.getCanvas().style.cursor = this._currentStyle;
    }
}
//# sourceMappingURL=cursorstylehandler.js.map